// stores
import store from '~/components/betslip/betslip.store';

export class CookieHelper {
	private isBrowser: boolean;
	private updateClient: (key: string, val: any) => void;

	constructor() {
		this.isBrowser = typeof window !== 'undefined';
		this.updateClient = store.getState().updateClient;
	}

	public isString(testString: string): boolean {
		return typeof testString === 'string';
	}

	public getCookie(cookieName: string, browserCookie: boolean): string {
		let cookieString = '';
		let cookieArray: Array<string> = [];

		try {
			if (browserCookie) {
				cookieArray = decodeURIComponent(document.cookie)
					.split(';')
					.filter(cookie => {
						const splitCookie = cookie.split('=');

						return splitCookie[0].indexOf(cookieName) !== -1;
					});

				if (cookieArray.length > 0) {
					cookieString = cookieArray.shift()?.split('=').pop() || '';
				}
			} else {
				// TODO: to support the implementation on old stack
				// we will need to add cookies during store init...
				cookieString = store.getState().client.config[`${cookieName}Cookie`];
			}

			return cookieString;
		} catch (e) {
			return '';
		}
	}

	public getCookieFromPreferedSource(cookieName: string): string {
		let cookieString: string = '';

		// Client side use the browser cookie.
		if (this.isBrowser) {
			cookieString = this.getCookie(cookieName, true);

			// //sync baobabCookie with browser when neccessary.
			// const baobabCookie = this.getCookie(cookieName, false);

			// if (baobabCookie !== cookieString) {
			//     this.setBaobabCookie(cookieName, cookieString);
			// }

			// Server side use the value in Baobab.
		} else {
			cookieString = this.getCookie(cookieName, false);
		}

		if (cookieString) {
			return cookieString;
		}

		return '';
	}

	public setBrowserCookie(
		cookieName: string,
		value: string,
		expiry: number,
	): void {
		const config = `; expires=${new Date(expiry).toUTCString()} ; path=/;`;
		document.cookie = `${cookieName}=${encodeURIComponent(value)}${config}`;
	}

	public setBaobabCookie(cookieName: string, value: string): void {
		try {
			this.updateClient(value, ['config', `${cookieName}Cookie`]);
		} catch (e) {
			console.log('DataStore has been dropped');
		}
	}
}

export interface ICookieService {
	cookieName: string;
	cookieValue: string;
	getArray(): Array<any>;

	getString(): string;
	helper: CookieHelper;
	// methods
	select(cookieName: string): CookieService;
	set(valueString?: string, expiry?: number): void;
	setArrayString(
		cookieBetIdArray: Array<any>,
		divider?: string,
		divider2?: string,
	): string;
}

export class CookieService implements ICookieService {
	cookieValue: string;
	cookieName: string;
	helper: CookieHelper;

	constructor() {
		this.cookieName = '';
		this.cookieValue = '';
		this.helper = new CookieHelper();
	}

	public select(cookieName: string) {
		if (this.helper.isString(cookieName)) {
			this.cookieName = cookieName;
		} else {
			throw 'Cookie name is not a string';
		}

		return this;
	}

	public getString(): string {
		this.cookieValue = this.helper.getCookieFromPreferedSource(this.cookieName);

		if (this.cookieValue !== null) {
			return this.cookieValue;
		}
		return '';
	}

	public getArray(
		divider = ',',
		transform?: (T: any) => Array<typeof T>,
	): Array<any> {
		this.cookieValue = this.helper.getCookieFromPreferedSource(this.cookieName);

		if (this.cookieValue !== null) {
			const val = this.cookieValue.split(divider);

			if (transform) {
				return val.map(transform);
			}
			return val;
		}
		return [];
	}

	// Reset cookie with updated value, and return value to be used elsewhere if neccessary
	public setArrayString(
		cookieBetIdArray: Array<any>,
		divider = ',',
		divider2 = '~',
	): string {
		const cookieString = cookieBetIdArray
			.map(id => id.join(divider2))
			.join(divider);

		const expiry = new Date().getTime() + 86400000;

		this.select(this.cookieName).set(cookieString, expiry);

		return cookieString;
	}

	public set(valueString = '', expiry = 0): void {
		if (this.helper.isBrowser) {
			this.helper.setBrowserCookie(this.cookieName, valueString, expiry);
		}

		this.helper.setBaobabCookie(this.cookieName, valueString);
	}
}
